module.exports = __webpack_public_path__ + "static/dynamic-realtime-7ec61ec9efd2feafe723e7dbc00d4c36.png";